import { del, get, post, put } from "./client";

export interface SmsConfig {
  provider: "sms_ir";
  is_enabled: boolean;
  has_api_key: boolean;
  line_number: string | null;
}
export interface SmsContact {
  id: string;
  name: string;
  phone_number: string;
  is_active: boolean;
}
export type ContactInput = Omit<SmsContact, "id">;
export const getSmsConfig = () => get<SmsConfig>("/sms/config");
export const saveSmsConfig = (data: Omit<SmsConfig, "has_api_key"> & { api_key?: string; clear_api_key?: boolean }) => put<SmsConfig>("/sms/config", data);
export const listSmsContacts = () => get<SmsContact[]>("/sms/contacts");
export const saveSmsContact = (data: ContactInput, id?: string) => id ? put<SmsContact>(`/sms/contacts/${id}`, data) : post<SmsContact>("/sms/contacts", data);
export const deleteSmsContact = (id: string) => del(`/sms/contacts/${id}`);
export const sendSmsTest = (contact_ids: string[], text: string) => post<{ accepted: boolean; recipient_count: number }>("/sms/test-message", { contact_ids, text });
